import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTVAuth } from './TVContext';
import { useDpadNavigation, focusFirst } from './focus';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TVSignIn = () => {
  const navigate = useNavigate();
  const { setTVToken } = useTVAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useDpadNavigation(() => navigate('/tv'));
  React.useEffect(() => { focusFirst(); }, []);

  const submit = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    setError('');
    if (!email || !password) { setError('Enter email and password.'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/tv/signin`, { email: email.trim(), password });
      setTVToken(res.data.token, res.data.user);
      navigate('/tv/browse');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Sign in failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tv-root" data-testid="tv-signin-screen">
      <div className="tv-header">
        <div className="tv-brand">PULSE MEDIA</div>
        <div className="tv-user">Sign In</div>
      </div>
      <div style={{ maxWidth: 640, margin: '0 auto', padding: '48px 32px' }}>
        <h1 style={{ fontSize: 48, fontWeight: 800, margin: 0 }}>Welcome back</h1>
        <p style={{ color: '#a8b8cf', fontSize: 20, marginTop: 12 }}>
          Sign in with your Pulse Media account to continue on this TV.
        </p>
        <form onSubmit={submit} style={{ marginTop: 32 }}>
          <label style={labelStyle}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="tv-focusable"
            style={inputStyle}
            data-testid="tv-signin-email"
            placeholder="you@example.com"
          />
          <label style={labelStyle}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="tv-focusable"
            style={inputStyle}
            data-testid="tv-signin-password"
            placeholder="••••••••"
          />
          {error && <div style={{ color: '#ff8b8b', marginTop: 16, fontSize: 18 }} data-testid="tv-signin-error">{error}</div>}
          <div style={{ marginTop: 28, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            <button type="submit" className="tv-btn tv-focusable" disabled={loading} data-testid="tv-signin-submit">
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
            <button type="button" className="tv-btn tv-btn-ghost tv-focusable" onClick={() => navigate('/tv/signup')} data-testid="tv-signin-to-signup">
              Create an account
            </button>
            <button type="button" className="tv-btn tv-btn-ghost tv-focusable" onClick={() => navigate('/tv')} data-testid="tv-signin-back">
              Use QR code instead
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const labelStyle = { display: 'block', color: '#a8b8cf', fontSize: 16, marginTop: 20, marginBottom: 8, fontWeight: 600 };
const inputStyle = {
  width: '100%',
  padding: '18px 20px',
  fontSize: 22,
  background: 'rgba(255,255,255,0.06)',
  color: '#eaf2ff',
  border: '3px solid rgba(255,255,255,0.12)',
  borderRadius: 12,
  outline: 'none',
};

export default TVSignIn;
